import React from 'react';
import { countries, customerLogos } from '../data/content';
export function LogoWall() {
  return <section className="w-full pb-16 pt-24 sm:pt-28" aria-labelledby="logos-heading" data-id="element-759" data-mp="626vzi247weq">
      <div className="mx-auto max-w-shell px-6" data-id="element-760" data-mp="3og6ai3f4ttvd">
        <h2 id="logos-heading" className="display text-center text-[28px] font-semibold text-ink sm:text-[32px]" data-id="element-761" data-mp="3ohhea38kv1mh">
          Trusted by 15,000+ businesses across
        </h2>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-762" data-mp="k2hmgjzij8zd">
          {countries.map(country => <li key={country.code} className="flex items-center gap-2 text-[15px] font-medium text-ink-soft" data-id="element-763" data-mp="b10andt51tgh">
              <img src={`https://flagcdn.com/w40/${country.code}.png`} alt="" aria-hidden="true" className="h-[14px] w-[21px] rounded-[2px] object-cover ring-1 ring-ink/10" data-id="element-764" data-mp="fzuv0k6r7q2p" />
              {country.name}
            </li>)}
        </ul>

      </div>

      <div className="logo-marquee group relative mt-12 w-full overflow-hidden" data-id="element-765" data-mp="27fhnbnwfgqfp">
        <ul className="sr-only" data-id="element-766" data-mp="22geo4k34pefn">
          {customerLogos.map(logo => <li key={logo.name} data-id="element-767" data-mp="2hcmclwlkl20q">{logo.name}</li>)}
        </ul>
        <div className="logo-marquee-track flex w-max items-center" aria-hidden="true" data-id="element-768" data-mp="2hat4ecvb69qm">
          {[0, 1].map(copy => <ul key={copy} className="flex shrink-0 items-center" data-id="element-769" data-mp="2qdar0sevl4e5">
              {customerLogos.map(logo => <li key={`${copy}-${logo.name}`} className="flex h-16 w-[150px] shrink-0 items-center justify-center px-5 sm:w-[180px] sm:px-7" data-id="element-770" data-mp="2lf96e31swx0k">
                  <img src={logo.src} alt="" loading="lazy" className="max-h-full max-w-full object-contain mix-blend-multiply" data-id="element-771" data-mp="302ly69i7byze" />
                </li>)}
            </ul>)}
        </div>
      </div>
    </section>;
}